import SimpleContainer from 'components/InputsMex/containers/SimpleContainer';
import { DropDown, TextInput, UniqueId } from 'components/InputsMex/inputs';
import React from 'react';

const BeneficiariosForm = ({ porcentajes, parentescos = [] }) => {
  return (
    <React.Fragment>
      <UniqueId />
      <div className="container-fluid">
        <div className="row justify-content-center">
          <div className="form-group col-7">
            <SimpleContainer label="Nombres:" name="nombres">
              <TextInput
                inputProps={{ name: 'nombres' }}
                rules={{
                  required: 'Obligatorio',
                  maxLength: {
                    value: 25,
                    message: 'Debe ingresar máximo 25 caracteres',
                  },
                }}
              />
            </SimpleContainer>
          </div>

          <div className="form-group col-7">
            <SimpleContainer label="Apellido paterno:" name="apellidoPaterno">
              <TextInput
                inputProps={{ name: 'apellidoPaterno' }}
                rules={{
                  required: 'Obligatorio',
                  maxLength: {
                    value: 20,
                    message: 'Debe ingresar máximo 20 caracteres',
                  },
                }}
              />
            </SimpleContainer>
          </div>

          <div className="form-group col-7 ">
            <SimpleContainer label="Apellido materno:" name="apellidoMaterno">
              <TextInput
                inputProps={{ name: 'apellidoMaterno' }}
                rules={{
                  maxLength: {
                    value: 20,
                    message: 'Debe ingresar máximo 20 caracteres',
                  },
                }}
              />
            </SimpleContainer>
          </div>

          <div className="form-group col-7 ">
            <SimpleContainer
              label="RFC:"
              name="rfc"
              helpText="Este campo es opcional"
            >
              <TextInput
                inputProps={{ name: 'rfc' }}
                rules={{
                  pattern: {
                    value: /^[A-Z]{4}[0-9]{6}[A-Z0-9]{3}$/,
                    message:
                      'RFC incorrecto, el formato esperado es: AAAA######***. Donde A es una letra, # es un número y los últimos 3 caracteres son alfanuméricos',
                  },
                  maxLength: {
                    value: 13,
                    message: 'Solo puede ingresar un máximo de 13 caracteres',
                  },
                }}
              />
            </SimpleContainer>
          </div>

          <div className="form-group col-7 ">
            <SimpleContainer label="Parentesco:" name="parentesco">
              <DropDown
                name="parentesco"
                options={parentescos}
                rules={{ required: 'Obligatorio' }}
              />
            </SimpleContainer>
          </div>

          <div className="form-group col-7 ">
            <SimpleContainer
              label="Porcentaje:"
              name="porcentaje"
              helpText={`Porcentaje disponible ${porcentajes.disponible}`}
            >
              <TextInput
                inputProps={{ name: 'porcentaje', isNumberInt: true }}
                hideArrows
                rules={{
                  required: 'Obligatorio',
                  max: {
                    value: 100,
                    message: 'El valor máximo a ingresar solo puede ser de 100%',
                  },
                  min: {
                    value: 1,
                    message: 'El valor mínimo a ingresar solo puede ser de 1%',
                  },
                  validate: {
                    porcentaje: (value) => {
                      if (value > porcentajes.disponible) {
                        return `Solo esta dispobile el ${porcentajes.disponible}%`;
                      }
                      return true;
                    },
                  },
                }}
              />
            </SimpleContainer>
          </div>

          <div className="form-group col-7 ">
            <SimpleContainer label="Sexo:" name="sexo">
              <DropDown
                name="sexo"
                options={[
                  { value: 'M', label: 'Masculino' },
                  { value: 'F', label: 'Femenino' },
                ]}
              />
            </SimpleContainer>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default BeneficiariosForm;
